import GameSearchBar from "@/components/GameSearchBar";
import HeroBanner from "@/components/HeroBanner";
import {buildBannerSlide} from "@/components/HeroBanner/buildBannerSlide";
import LiveBetFeed from "@/components/Home/LiveBetFeed/LiveBetFeed";
import LiveWinners from "@/components/Home/LiveWinners/LiveWinners";
import TopReferrals from "@/components/Home/TopReferrals/TopReferrals";
import LazySection from "@/components/LazySection";
import HomeNewsCarousel from "@/components/news/HomeNewsCarousel/HomeNewsCarousel";
import {StoriesCarousel} from "@/components/Stories";
import {GamePromos} from "@/pages/private/Games/components/List/components";
import {FavoriteGamesCarousel} from "@/pages/private/Games/components/List/components/favorite-games-carousel";
import {RecentGames} from "@/pages/private/Games/components/List/components/recent-games";
import {RecentlyPlayedGames} from "@/pages/private/Games/components/List/components/recently-played-games";
import {TopGames} from "@/pages/private/Games/components/List/components/top-games";
import {TopPayingGames} from "@/pages/private/Games/components/List/components/top-paying-games";
import AnimalitosExpressCarousel from "./components/AnimalitosExpressCarousel";
import {BreakingLeague} from "./components/BreakingLeague";
import {CategoryPills} from "./components/CategoryPills/CategoryPills";
import {CustomBoardCarousel} from "./components/CustomBoardCarousel/CustomBoardCarousel";
import {CustomCarousels} from "./components/CustomCarousels";
import GameCardHome from "./components/GameCardHome";
import HomePromoRow from "./components/HomePromoRow/HomePromoRow";
import LiveGames from "./components/LiveGames";
import LotteryGamesCarousel from "./components/LotteryGamesCarousel";
import MiniGamesCarousel from "./components/MiniGamesCarousel/MiniGamesCarousel";
import ThemesCarousel from "./components/ThemesCarousel/ThemesCarousel";

/**
 * Hardcoded Home layout — kept as fallback when CMS layout is disabled or unavailable.
 * @param {{ ctx: import("./homeLayoutContext").HomeLayoutContext }} props
 */
const LegacyHomeLayout = ({ctx}) => {
  const {
    t,
    authStatus,
    styles,
    heroBanners,
    filteredHomeGames,
    isHomeSearching,
    shouldHideCategoryPills,
    filterProviderOptions,
    filterClassOptions,
    homeActiveCategory,
    homeSearchTerm,
    customBoards,
    handleHomeSearch,
    handleHomeSearchSubmit,
    handleHomeProviderChange,
    handleOpenGame,
    setHomeActiveCategory,
    setStoreSearch,
    navigate,
    sectionsRef,
  } = ctx;

  return (
    <>
      <div className={styles.heroArea}>
        <StoriesCarousel />

        {authStatus === "unauthenticated" && heroBanners.length > 0 && (
          <HeroBanner slides={heroBanners.map(banner => buildBannerSlide(banner, {t}))} />
        )}

        <GameSearchBar
          onSearch={handleHomeSearch}
          onSubmit={handleHomeSearchSubmit}
          placeholder={t("homeSearchPlaceholder", {defaultValue: "Buscar juegos, proveedores..."})}
          providerOptions={filterProviderOptions}
          categoryOptions={filterClassOptions}
          activeProvider=""
          activeCategory={homeActiveCategory}
          onProviderChange={handleHomeProviderChange}
          onCategoryChange={setHomeActiveCategory}
          resultCount={isHomeSearching ? filteredHomeGames.length : undefined}
        />

        {!shouldHideCategoryPills && <CategoryPills />}

        {isHomeSearching && (
          <div className={styles.homeSearchResults}>
            {filteredHomeGames.length > 0 ? (
              <>
                <div className={styles.homeSearchGrid}>
                  {filteredHomeGames.slice(0, 12).map(game => (
                    <GameCardHome
                      key={game.id}
                      game={game}
                      handleOpenGame={handleOpenGame}
                    />
                  ))}
                </div>
                {filteredHomeGames.length > 12 && (
                  <button
                    type="button"
                    className={styles.homeSearchSeeAll}
                    onClick={() => {
                      setStoreSearch(homeSearchTerm);
                      navigate("/gameslist/all");
                    }}
                  >
                    {t("seeAllResults", {
                      defaultValue: `Ver todos los resultados (${filteredHomeGames.length})`,
                    })}
                  </button>
                )}
              </>
            ) : (
              <p className={styles.homeSearchEmpty}>{t("noGamesFound", {defaultValue: "No se encontraron juegos"})}</p>
            )}
          </div>
        )}

        <BreakingLeague />

        <div className={styles.sectionBlock}>
          <TopGames />
        </div>

        {customBoards?.map(board => (
          <div
            key={board.id}
            className={styles.sectionBlock}
          >
            <CustomBoardCarousel board={board} />
          </div>
        ))}

        <div className={styles.sectionBlock}>
          <MiniGamesCarousel />
        </div>

        <LazySection
          className={styles.sectionBlock}
          minHeight={280}
        >
          <TopPayingGames />
        </LazySection>

        {authStatus === "authenticated" && (
          <LazySection
            className={styles.sectionBlock}
            minHeight={280}
          >
            <FavoriteGamesCarousel />
          </LazySection>
        )}

        {authStatus === "authenticated" && (
          <LazySection
            className={styles.sectionBlockAlt}
            minHeight={280}
          >
            <RecentlyPlayedGames />
          </LazySection>
        )}

        <LazySection
          className={styles.sectionBlock}
          minHeight={280}
        >
          <LotteryGamesCarousel />
        </LazySection>

        <LazySection
          className={styles.sectionBlockAlt}
          minHeight={280}
        >
          <AnimalitosExpressCarousel />
        </LazySection>

        <LazySection
          className={styles.sectionBlockAlt}
          minHeight={200}
        >
          <LiveGames />
        </LazySection>

        <div
          className={styles.glowPromos}
          data-glow
          data-visible="false"
          aria-hidden="true"
        />
        <LazySection minHeight={200}>
          <GamePromos />
        </LazySection>
      </div>
      <LazySection
        className={styles.sectionBlockAlt}
        minHeight={280}
      >
        <CustomCarousels />
        <RecentGames />
      </LazySection>

      <div className={styles.heroArea}>
        <div className={styles.sectionBlockAlt}>
          <CustomCarousels />
          <RecentGames />
        </div>
      </div>
      <LazySection minHeight={300}>
        <div style={{position: "relative"}}>
          {!isHomeSearching && <ThemesCarousel />}
          {!isHomeSearching && <HomeNewsCarousel />}
        </div>
      </LazySection>

      <div
        className={styles.homeSections}
        ref={sectionsRef}
      >
        <LazySection minHeight={400}>
          <div
            className={styles.homeStatsGrid}
            style={{padding: "0", margin: "16px 0"}}
          >
            <LiveWinners />
            <LiveBetFeed />
            <TopReferrals />
          </div>
        </LazySection>
        <HomePromoRow ctx={ctx} />
      </div>
    </>
  );
};

export default LegacyHomeLayout;
